import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Mail, Lock, Eye, EyeOff } from 'lucide-react';
export function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Simulate login process
    setTimeout(() => {
      setIsLoading(false);
      // This is a fake login, so we don't actually authenticate
      alert('This is a demo login. In a real app, authentication would happen here.');
    }, 1500);
  };
  return <div className="min-h-screen w-full bg-[#f0f7ff] flex flex-col" data-id="element-200">
      <div className="container mx-auto px-4 py-8" data-id="element-201">
        <Link to="/" className="inline-flex items-center text-gray-700 hover:text-blue-500 mb-8" data-id="element-202">
          <ArrowLeft size={20} className="mr-2" data-id="element-203" />
          Back to Home
        </Link>
        <div className="max-w-md mx-auto bg-white rounded-lg shadow-md p-8" data-id="element-204">
          <div className="text-center mb-8" data-id="element-205">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tZt8Y24BXXUUFMEFqS2eFe/sport-pro-04-min_2.png" alt="SportProZ Logo" className="h-16 mx-auto mb-4" data-id="element-206" />
            <h1 className="text-2xl font-bold text-gray-800" data-id="element-207">
              Log in to your account
            </h1>
            <p className="text-gray-600 mt-2" data-id="element-208">
              Enter your credentials to access your account
            </p>
          </div>
          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-209">
            <div data-id="element-210">
              <label htmlFor="email" className="block text-gray-700 font-medium mb-2" data-id="element-211">
                Email Address
              </label>
              <div className="relative" data-id="element-212">
                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-213">
                  <Mail size={18} className="text-gray-500" data-id="element-214" />
                </div>
                <input type="email" id="email" value={email} onChange={e => setEmail(e.target.value)} className="w-full pl-10 px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="athlete@example.com" required data-id="element-215" />
              </div>
            </div>
            <div data-id="element-216">
              <div className="flex items-center justify-between mb-2" data-id="element-217">
                <label htmlFor="password" className="block text-gray-700 font-medium" data-id="element-218">
                  Password
                </label>
                <a href="#" className="text-sm text-blue-500 hover:text-blue-600" data-id="element-219">
                  Forgot password?
                </a>
              </div>
              <div className="relative" data-id="element-220">
                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-221">
                  <Lock size={18} className="text-gray-500" data-id="element-222" />
                </div>
                <input type={showPassword ? 'text' : 'password'} id="password" value={password} onChange={e => setPassword(e.target.value)} className="w-full pl-10 px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="••••••••" required data-id="element-223" />
                <button type="button" className="absolute inset-y-0 right-0 flex items-center pr-3" onClick={() => setShowPassword(!showPassword)} data-id="element-224">
                  {showPassword ? <EyeOff size={18} className="text-gray-500" data-id="element-225" /> : <Eye size={18} className="text-gray-500" data-id="element-226" />}
                </button>
              </div>
            </div>
            <div className="flex items-center" data-id="element-227">
              <input id="remember-me" type="checkbox" className="h-4 w-4 text-blue-500 border-gray-300 rounded focus:ring-blue-500" data-id="element-228" />
              <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-700" data-id="element-229">
                Remember me
              </label>
            </div>
            <button type="submit" disabled={isLoading} className="w-full bg-blue-500 hover:bg-blue-600 text-white font-bold py-3 px-4 rounded-md transition-colors flex justify-center items-center" data-id="element-230">
              {isLoading ? <svg className="animate-spin -ml-1 mr-2 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-231">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-232"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-233"></path>
                </svg> : null}
              {isLoading ? 'Logging in...' : 'Log in'}
            </button>
          </form>
        </div>
      </div>
    </div>;
}